/* unplugin-vue-components disabled */import { render } from "./MmUserAgreement.vue?vue&type=template&id=3d84fb50&scoped=true"
import script from "./MmUserAgreement.vue?vue&type=script&lang=js"
export * from "./MmUserAgreement.vue?vue&type=script&lang=js"

import "./MmUserAgreement.vue?vue&type=style&index=0&id=3d84fb50&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d84fb50"]])

export default __exports__